module.exports = __webpack_public_path__ + "img/pp4.52e3a76a.png";